import React from 'react';
import './Services.css';
import { LampDemo } from './ui/LampContainer';

const Services = () => {
  return (
    <section className="services-section">
      <div className='LampLight'>
        <LampDemo/>
        </div>
    </section>
  );
};

export default Services;
